import { useTranslation } from "react-i18next"

import useArticleClasses from "./useArticleClasses"

export default function useTechnicalData() {
    const { t } = useTranslation()
    const {
        fetchArtcleClasses,
        articleClassHasField,
        getArticleClassSpecificFields,
    } = useArticleClasses()

    const QuickCouplingSystemTypes = new Map([
        ["SWA 33", t("quickCouplingSystemType.SWA 33")],
        ["SWA 48", t("quickCouplingSystemType.SWA 48")],
        ["SWA 48-10", t("quickCouplingSystemType.SWA 48-10")],
        ["SWA 66", t("quickCouplingSystemType.SWA 66")],
        ["SWA 77", t("quickCouplingSystemType.SWA 77")],
        ["SW 2Q", t("quickCouplingSystemType.SW 2Q")],
        ["SW 3", t("quickCouplingSystemType.SW 3")],
        ["Multiconnect MC-FPL XL", t("quickCouplingSystemType.Multiconnect MC-FPL XL")],
        ["SI10", t("quickCouplingSystemType.SI10")],
        ["SI18", t("quickCouplingSystemType.SI18")],
        ["OQ70/55", t("quickCouplingSystemType.OQ70/55")],
        ["T620/720", t("quickCouplingSystemType.T620/720")],
        ["Geel SW020", t("quickCouplingSystemType.Geel SW020")],
        ["Geel SW035", t("quickCouplingSystemType.Geel SW035")],
        ["A-Lock 3 Combi", t("quickCouplingSystemType.A-Lock 3 Combi")],
        ["Engl SW050", t("quickCouplingSystemType.Engl SW050")],
        ["HS21", t("quickCouplingSystemType.HS21")],
        ["Direkt", t("quickCouplingSystemType.Direkt")],
        ["Multiconnect MCFPL -L", t("quickCouplingSystemType.Multiconnect MCFPL -L")],
        ["OQ60-5", t("quickCouplingSystemType.OQ60-5")],
        ["SW Claas Scorpion", t("quickCouplingSystemType.SW Claas Scorpion")],
        ["SW LH", t("quickCouplingSystemType.SW LH")],
        ["SW Manitou", t("quickCouplingSystemType.SW Manitou")],
        ["SI12", t("quickCouplingSystemType.SI12")],
    ])

    const ConnectionTypes = new Map([
        ["Likufix", t("connectionType.Likufix")],
        ["Likufix - 9", t("connectionType.Likufix - 9")],
        ["manually", t("connectionType.manually")],
        ["Q (Mitteldruck)", t("connectionType.Q (Mitteldruck)")],
        ["fully hydraulic", t("connectionType.fully hydraulic")],
    ])

    const LockingTypes = new Map([
        ["hydraulic", t("locking.hydraulic")],
        ["mechanic", t("locking.mechanic")],
    ])

    const ControlSystemTypes = new Map([
        ["Litiu", t("controlSystem.Litiu")],
        ["Rototop RT 201", t("controlSystem.Rototop RT 201")],
        ["Powertilt", t("controlSystem.Powertilt")],
        ["Rototop RT 251", t("controlSystem.Rototop RT 251")],
        ["Tiltrotator", t("controlSystem.Tiltrotator")],
        ["Snap It", t("controlSystem.Snap It")],
    ])

    const AgilityTypes = new Map([
        ["fixed", t("agility.fixed")],
        ["slewing", t("agility.slewing")],
        ["rotary", t("agility.rotary")],
    ])

    return {
        fetchArtcleClasses,
        articleClassHasField,
        getArticleClassSpecificFields,
        QuickCouplingSystemTypes,
        ConnectionTypes,
        LockingTypes,
        ControlSystemTypes,
        AgilityTypes,
    }
}
